export const ANALYTICS = '/analytics' as const
export const ANALYTICS_ADMISSION_OFFICE = `${ANALYTICS}/admission-office` as const
